export const CALENDLY_REGEX =
  /(?:https?:\/\/)?(?:www\.)?calendly\.com\/([a-zA-Z0-9_-]+)(?:\/[\w-]+)?/
export const CALENDLY_LINK = 'https://calendly.com/'
export const DEFAULT_SERVICE_NAME = 'DEFAULT'
export const WEBSITE_ANALYSIS_TIMEOUT = 7000
export const ANALYSIS_COMPLETE_TIMEOUT = 3
export const DEFAULT_TEMPERATURE = 0.5
export const CHANGE_WEBSITE_MESSAGE =
  "Changing website will overwrite your assistant's settings, potentially erasing customizations you have made previously. Are you sure you want to continue?"
export const DELETE_WEBSITE_MESSAGE =
  'Are you sure you want to delete? Your assistant will no longer be trained on your website if deleted.'
export const CHANGE_SERVICE_MESSAGE =
  "We can update your questions and facts based on this new service. Do you want us to change those, overwriting any customizations you've added?"
export const DEFAULT_PHONE_PATIENCE = 320
